import { useRouter } from 'next/router';
export var useLimitOrderRouter = function useLimitOrderRouter() {
  var _useRouter = useRouter(),
      route = _useRouter.route;

  return route === '/limit-order';
};